import React, { useState, useEffect } from "react";
 import '../css/edit_style.css'
//import '../css/edit_style.min.css'
import Logo from '../images/logo.png'
import { apiCallingPost } from "../service";
import AWS from "aws-sdk";
var s3;

function Login() {
    const [userName, setUserName] = useState("")
    const [password, setPassword] = useState("")
    const [loginError, setloginError] = useState("")
    const [loginErrorFlag, setloginErrorFlag] = useState(false)
    const [emailId, setEmailId] = useState("")
    const [showDiv, SetshowDiv] = useState(false)
    const [showLoginDiv, SetLoginDiv] = useState(true)
    const [s3BucketMainFolder, setS3BucketMainFolder] = useState("")
    const [accessKey, setAccessKey] = useState("")
    const [secretKey, setSecretKey] = useState("")
    const [s3bucket, setS3bucket] = useState("")
    const [s3Details, setS3Details] = useState("")

    useEffect(() => {
        getAwsDetails();
    }, [])

    const getAwsDetails = () => {
        let postData = {
          functionName: "awsCredentials"
        };
        apiCallingPost(postData).then((data) => {
          console.log("decoded", data)
          if (data.data.success === "1") {
            var decoded = data.data.result.s3Details;
            console.log("decoded111", decoded)
            window.sessionStorage.setItem('S3BucketMainFolder', decoded.mainFolder);
            window.sessionStorage.setItem('Bucket', decoded.s3bucket);
    
            AWS.config.update({
              accessKeyId: decoded.accessKey,
              secretAccessKey: decoded.secretKey,
              region: "ap-south-1"
            });
            var bucketParams = {
              Bucket: decoded.s3bucket
            };
            console.log("bucketParams---", bucketParams);
            s3 = new AWS.S3({ apiVersion: "2006-03-01", params: bucketParams });
            console.log("s3---", s3);
            window.sessionStorage.setItem('s3Details', s3);
            console.log("s3-session--", window.sessionStorage.getItem('s3Details'));
            setS3Details(s3)
            setS3BucketMainFolder(decoded.mainFolder)
            setAccessKey(decoded.accessKey)
            setSecretKey(decoded.secretKey)
            setS3bucket(decoded.s3bucket)
            // resolve(true);
          }
          else {
            // console.log('error:home:getAwsDetails:', data.errorMessage)
          }
        })
        // })
    }
    const setLoginHandler = (e) => {
        if (userName === "") {
            setloginError("Username required")
            setloginErrorFlag(true)
        }
        else if (password === "") {
            setloginError("Password required")
            setloginErrorFlag(true)
        }
        else {
            setloginErrorFlag(false)
            let postData = {
                functionName: "login",
                username: userName,
                password: password
            };
            apiCallingPost(postData).then((data) => {
                // console.log('getUserAuthentication-- ', data)
                if (data.data.success == "1") { 
                    window.sessionStorage.setItem("user_id", data.data.result.userData[0].userId)
                    window.sessionStorage.setItem("username", data.data.result.userData[0].username)
                    window.sessionStorage.setItem("roleName", data.data.result.userData[0].roleName)
                    if (data.data.result.userData[0].roleName == "Admin" || data.data.result.userData[0].roleName == "SuperAdmin") {
                        window.sessionStorage.setItem("isLogedIn", "1")
                        // window.sessionStorage.setItem("isEditor", data.data.result.userData[0].isEditor)
                        if (data.data.result.userData[0].roleName == "Admin") {
                             window.location.href = '/enquire-details'
                        }
                        else {
                            window.location.href = '/dashboard'
                        }
                    }
                    else {
                        // console.log("not Admin || SuperAdmin");
                        window.location.href = '/login'
                        window.sessionStorage.setItem("isLogedIn", "0")
                    }
                }
                else {
                    // console.log("Username Or Password Is InValid.");
                    setloginError("Username Or Password Is InValid.")
                    setloginErrorFlag(true)
                }
            })
        }
    }
    const forgetPassword = () => {
        var characters = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
        if (emailId === "") {
            setloginError("Email required")
            setloginErrorFlag(true)
        }
        else if (emailId.includes("@") && characters.test(emailId) === false) {
            setloginError("Invalid Email Address")
            setloginErrorFlag(true)
        }
        else {
            setloginErrorFlag(false)
            const postData = {
                "functionName": "sendMail",
                "toMailId": emailId
            }
            // console.log("forgot----------", postData);
            apiCallingPost(postData).then((data) => {
                // console.log("forget...................", data)
                if (data.data.success === "1") {
                    alert("success")
                }
                else if (data.data.errorMessage) {
                    alert("Invalid Email")
                }
            })
        }
    }
    const gotoForget = () => {
        SetshowDiv(true)
        SetLoginDiv(false)
    }
    const OngoLogin = () => {
        SetshowDiv(false)
        SetLoginDiv(true)
    }
    return (
        <div className='login_wrapper'>
            <div className='left_login'>
                <div className='login_logo'>
                    <img src={Logo} className="img_logo" alt="logo" />
                </div>
                {/* <h1 className='login_header'>Welcome! At <br /> Himalaya Dashboard</h1> */}
                <h1 className='login_header'>Welcome to the Himalaya Hyperlocal Content Management System</h1>
            </div>
            <div className='right_login'>
                {showLoginDiv &&
                    <div className='right_login_inner'>
                        <h2 className='right_loginhead'>Login</h2>
                        {loginErrorFlag === true &&
                            <label id="loginError" className="inputError"> {loginError} </label>
                        }
                        <div className="form_div">
                            <input
                                type='text'
                                id="username"
                                placeholder="Username"
                                className='form_login'
                                value={userName}
                                onChange={(e) => setUserName(e.target.value)}
                            />
                        </div>
                        <div className="form_div">
                            <input
                                type='password'
                                id="password"
                                placeholder="Password"
                                className='form_login'
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                            />
                        </div>
                        <button
                            type='submit'
                            className='login_btn'
                            onClick={() => setLoginHandler()}
                        >  Login
                        </button>
                        {/* <div className="backto_login">Forgot Password? 
                    <span className="backto_loginspan" 
                        onClick={()=>gotoForget()}
                    > Click here</span>
                    </div> */}
                    </div>
                }

                {showDiv &&
                    <div className="right_login_forget">
                        <h2 className='right_loginhead'>FORGOT PASSWORD</h2>
                        {loginErrorFlag === true &&
                            <label id="emailError" className="inputError"> {loginError} </label>
                        }
                        <div className="form_div">
                            <input
                                type='email'
                                placeholder="Email"
                                className='form_login'
                                value={emailId}
                                onChange={(e) => setEmailId(e.target.value)}
                            />
                        </div>
                        <button
                            type='submit'
                            className='login_btn'
                            onClick={() => forgetPassword()}
                        >Submit
                        </button>
                        <div className="backto_login">
                            Back to <span className="backto_loginspan" onClick={() => OngoLogin()}>login</span>
                        </div>
                    </div>
                }
            </div>
        </div>
    );
}

export default Login;
